import { Component, Input } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { BaseControlComponent } from '../base-control.component';

@Component({
  selector: 'boi-date-picker',
  templateUrl: './date-picker.component.html',
  styleUrls: ['./date-picker.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: DatePickerComponent,
      multi: true
    }
  ],
  exportAs: 'boi-date-picker'
})
export class DatePickerComponent extends BaseControlComponent {
  @Input() public min: Date;
  @Input() public max: Date;
  @Input() public format: string;
  @Input() public placeholder: string;
  @Input() public isTooltipLast = true;
  @Input() public showCalendar = true;

  public get value(): any {
    return this.innerValue;
  }

  public set value(newValue: any) {
    if (newValue !== this.innerValue) {
      this.innerValue = this.normalizeDate(newValue);
      this.onChangeCallback(this.innerValue);
    }
  }

  public writeValue(value: any): void {
    if (value !== this.innerValue) {
      this.innerValue = this.normalizeDate(value);
    }
  }

  private normalizeDate(inputDate): Date | null {
    if (inputDate) {
      const day = inputDate.getDate();
      const month = inputDate.getMonth();
      const year = inputDate.getFullYear();

      inputDate.setUTCFullYear(year, month, day);
      inputDate.setUTCHours(0);
      inputDate.setUTCMinutes(0);
      inputDate.setUTCSeconds(0);
      inputDate.setUTCMilliseconds(0);
    }

    return inputDate;
  }
}
